import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { MakeupSettings } from './get-makeup-settings';

export type UpdateMakeupSettingsParams = Partial<MakeupSettings>;

export const updateMakeupSettingsAPI = async (
  params: UpdateMakeupSettingsParams,
) => {
  const response = await baseAPI.patch<MakeupSettings>(
    '/makeup/settings',
    params,
  );
  return response.data;
};

export const useUpdateMakeupSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMakeupSettingsAPI,
    onSuccess: (data) => {
      queryClient.setQueryData([KEYS.MAKEUP_SETTINGS], data);
    },
  });
};
